import API from "./api";
import * as routes from './_routes';

export function fetchCompany(companyId) {
    return API.get(routes.GET_COMPANY + companyId);
}
